module.exports = __webpack_public_path__ + "img/36.cd712d5f.png";